module.exports = "/images/logo-elements.svg?3ab499720f2e04a6aad4cf10c4f3a151";